import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";

export default function Spaces() {
  const [spaces, setSpaces] = useState([]);
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const navigate = useNavigate();

  const load = async () => setSpaces((await api.get("/spaces")).data);
  useEffect(() => { load(); }, []);

  const create = async () => {
    if (!name.trim()) return;
    await api.post("/spaces", { name: name.trim() });
    setName(""); setOpen(false);
    load();
    toast.success("Space created");
  };

  const del = async (id, e) => {
    e.stopPropagation();
    if (!window.confirm("Delete this space?")) return;
    await api.delete(`/spaces/${id}`);
    load();
  };

  return (
    <div className="relative min-h-screen px-10 pt-10">
      <div className="orb orb-purple" style={{ width: 700, height: 700, top: -220, left: -160, opacity: 0.35 }} />
      <div className="orb orb-orange" style={{ width: 500, height: 500, bottom: -200, right: -160, opacity: 0.15 }} />

      <div className="flex items-center justify-between mb-4 relative">
        <h1 className="serif-italic text-5xl text-white/85">All Spaces</h1>
        <button className="pill" onClick={() => setOpen(true)} data-testid="create-space-button">
          <span className="pill-dot" /> CREATE A NEW SPACE
        </button>
      </div>
      <div className="h-px bg-white/10 mb-10" />

      <div className="grid gap-x-10 gap-y-14 grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 relative">
        {spaces.map(s => (
          <div key={s.space_id} className="flex flex-col items-center cursor-pointer group" onClick={() => navigate(`/spaces/${s.space_id}`)} data-testid={`space-${s.space_id}`}>
            <div className="space-orb">
              <span className="serif-italic text-white/60 text-center px-4">{s.card_count === 0 ? <><span className="block text-sm">Empty</span><span>Space</span></> : s.name}</span>
            </div>
            <div className="mt-4 flex items-center gap-2">
              <span className="w-2 h-2 rounded-full" style={{ background: s.color }} />
              <span className="text-white/70">{s.name}</span>
              <button onClick={(e) => del(s.space_id, e)} className="opacity-0 group-hover:opacity-100 text-white/40 hover:text-white/80 transition-opacity">
                <Trash2 size={13} />
              </button>
            </div>
            <div className="text-xs text-white/40 mt-1">{s.card_count} cards</div>
          </div>
        ))}
        {spaces.length === 0 && <div className="text-white/40 col-span-full text-center py-16 serif-italic text-2xl">No spaces yet.</div>}
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-[color:var(--surface)] border-white/10">
          <DialogHeader><DialogTitle className="serif-italic text-2xl">Create a Space</DialogTitle></DialogHeader>
          <Input value={name} onChange={e => setName(e.target.value)} placeholder="Name" className="bg-white/5 border-white/10" data-testid="space-name-input" />
          <div className="flex justify-end"><Button onClick={create} style={{ background: "var(--orange)" }} data-testid="space-create-submit">Create</Button></div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
